<template>
  <div>
    <div>
      <Breadcrumb>
        <Breadcrumb-item href="#">题库</Breadcrumb-item>
        <Breadcrumb-item>英语能力信息列表</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <div class="container">
      <Form :label-width="80" label-position="left">
        <Row :gutter="32">
          <Col span="6">
            <FormItem label="能力信息：">
              <Input v-model="ability" placeholder="请输入能力信息"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="关联等级：">
              <Select v-model="aa">
                <Option value="1" key="1">1</Option>
                <Option value="2" key="2">2</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="4">
            <Button type="primary" @click="search">搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" @click="showCreateAbilityModal = true">添加能力信息</Button>
    </div>

    <List style="margin-top: 10px" :tableColumns="tableColumns" listUrl=""
        :params="queryParams" :reload="reload">
    </List>

    <Modal v-model="showUpdateAbilityModal" title="编辑能力信息">
      <Form class="form" :rules="Rules" ref="updateTemplateForm" :model="updateAbilityParams">
        <Row>
          <FormItem :label-width="90" label="能力信息名称：" prop='name'>
            <Input v-model="updateAbilityParams.name" placeholder="请输入能力信息名称"></Input>
          </FormItem>
          <FormItem :label-width="90" label="对应等级：" prop='type'>
            <Select v-model="updateAbilityParams.type" clearable placeholder="请选择关联等级">
              <Option value="video" key="1">录音题</Option>
              <Option value="read" key="2">阅读理解</Option>
              <Option value="listen" key="3">听力题</Option>
            </Select>
          </FormItem>
        </Row>
      </Form>
      <div slot="footer">
          <Button type="text" size="large" @click="showUpdateAbilityModal = false">取消</Button>
          <Button type="primary" size="large" @click="update">确定</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
export default {
  data(){
    let $moment = this.$moment
    return {
      reload: 0,
      showCreateAbilityModal: false,
      showUpdateAbilityModal: false,
      queryParams: {},
      updateAbilityParams: {},
      Rules:{
        name: [
          { type: 'string', required: true, message: '请输入模板名称', trigger: 'blur' },
          { pattern: /^[\u4E00-\u9FA5A-Za-z0-9]{2,20}$/, message: '只能输入中文、英文和数字', trigger: 'blur'}
        ],
        type: [
          { required: true, message: '请选择对应等级', trigger: 'blur' }
        ]
      },
      tableColumns: [
        {
          title: 'ID',
          key: 'id',
          align: 'center',
        },
        {
          title: '能力信息',
          key: '',
          align: 'center',
        },
        {
          title: '关联等级',
          key: '',
          align: 'center',
        },
        {
          title: '创建时间',
          align: 'center',
          render: (h, params)=>{
            let createTime = params.row.createTime
            return h('div', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '修改时间',
          align: 'center',
          render: (h, params)=>{
            let updateTime = params.row.modifiyTime
            return h('div', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params)=>{
            let row = params.row
            return h('a', {on: {click:()=> this.updateAbility(row)}}, '编辑')
          }
        }
      ]
    }
  },
  methods: {
    updateAbility(){

    }
  }

}
</script>

<style lang="less" scoped>
  .container {
    margin-top: 20px;
  }
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>>



// WEBPACK FOOTER //
// AbilityList.vue?0b2b657a